import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { facilities } from '../data/facilities';
export function Facilities() {
  return <div className="w-full bg-club-canvas" data-id="element-834">
      {/* Page Banner */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-835">
        <div className="absolute inset-0 z-0" data-id="element-836">
          <img src="https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Club Facilities" className="w-full h-full object-cover" data-id="element-837" />
          <div className="absolute inset-0 bg-club-navy/60 mix-blend-multiply" data-id="element-838"></div>
        </div>
        <div className="relative z-10 text-center px-4 mt-16" data-id="element-839">
          <motion.h1 className="text-5xl md:text-6xl font-serif text-white mb-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-840">
            Facilities
          </motion.h1>
          <motion.p className="text-lg text-club-canvas/80 font-light max-w-2xl mx-auto" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-841">
            Discover the exceptional amenities available exclusively to our
            members.
          </motion.p>
        </div>
      </section>

      {/* Facilities Grid */}
      <section className="py-20 px-4 max-w-7xl mx-auto" data-id="element-842">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-843">
          {facilities.map((facility, index) => <motion.div key={facility.id} className="group cursor-pointer bg-white border border-club-border rounded-sm overflow-hidden hover:shadow-md transition-shadow duration-300" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-844">
              <div className="aspect-[4/3] overflow-hidden relative" data-id="element-845">
                <img src={facility.image} alt={facility.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-846" />
                <div className="absolute top-4 left-4 bg-club-canvas/90 backdrop-blur-sm px-3 py-1 rounded-sm" data-id="element-847">
                  <span className="text-xs font-semibold tracking-wider uppercase text-club-green" data-id="element-848">
                    {facility.category}
                  </span>
                </div>
              </div>
              <div className="p-6" data-id="element-849">
                <h3 className="text-2xl mb-2 group-hover:text-club-gold transition-colors" data-id="element-850">
                  {facility.name}
                </h3>
                <p className="text-club-ink/70 text-sm mb-4 line-clamp-2" data-id="element-851">
                  {facility.desc}
                </p>
                <Link to={`/facilities/${facility.id}`} className="inline-flex items-center text-sm font-medium text-club-green group-hover:text-club-gold transition-colors" data-id="element-852">
                  View Details <ArrowRight size={14} className="ml-1" data-id="element-853" />
                </Link>
              </div>
            </motion.div>)}
        </div>
      </section>
    </div>;
}